// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"962":"934b349b","990":"e1d52e83"}[chunkId] + ".chunk.js";
};